import React from 'react';


 function card(props) {

    function cardBgColor() {
        if (props.title === 'Work') {
            return 'hsl(15, 100%, 70%)'
        } else if(props.title === 'Play') {
            return 'hsl(195, 74%, 62%)'
        } else if (props.title === 'Study') {
            return 'hsl(348, 100%, 68%)'
        } else if (props.title === 'Exercise') {
            return 'hsl(145, 58%, 55%)'
        } else if(props.title === 'Social') {
            return 'hsl(264, 64%, 52%)'
        } else if (props.title === 'Self Care') {
            return 'hsl(43, 84%, 65%)'
        }
    }

    const styles = {
        backgroundColor : cardBgColor()
    }

    return(
        <>
        <div className='dashboard-card' style={styles}>
            <div className="card-icon">
                <img src={props.cardIcon} alt="" />
            </div>
            <div className="card-info">
                <div className="card-title">
                    <span>{props.title}</span>
                    <img src="./images/icon-ellipsis.svg" alt="" />
                </div>
                <div className="card-timings">
                    <div className="current-time">
                        <h2>{props.currentTime}<span>hrs</span></h2>
                    </div>
                    <div className="prev-time">
                        <p>last week -<span> {props.prevTime}</span>hrs</p>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
export default card;